module.exports = __webpack_public_path__ + "img/orange_video_icon.4b4a452a.svg";